module.exports = __webpack_public_path__ + "static/media/become-a-member.2b0904ec.png";